import { Link, useLocation, useNavigate } from "react-router-dom";
import { Instagram } from "lucide-react";
import Logo from "@/components/Logo";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { INSTAGRAM, WHATSAPP_DEFAULT_MESSAGE, whatsappLink } from "@/data/site";

const linkClass = (active) =>
  `relative pb-1 text-[0.7rem] font-medium uppercase tracking-[0.25em] transition-colors duration-300 after:absolute after:bottom-0 after:left-0 after:h-px after:bg-navy after:transition-all after:duration-500 ${
    active ? "text-navy after:w-full" : "text-dusk after:w-0 hover:text-navy hover:after:w-full"
  }`;

export default function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const goContato = (e) => {
    e.preventDefault();
    const scroll = () =>
      document.getElementById("contato")?.scrollIntoView({ behavior: "smooth" });
    if (pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 450);
    } else {
      scroll();
    }
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-cloud bg-paper/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-3 md:px-12 md:py-4">
        <Link to="/" data-testid="header-logo-link" aria-label="SG Turismos — início">
          <Logo />
        </Link>

        <nav className="flex items-center gap-4 md:gap-9">
          <Link to="/" data-testid="nav-home" className={`${linkClass(pathname === "/")} hidden sm:block`}>
            Início
          </Link>
          <Link to="/album" data-testid="nav-album" className={linkClass(pathname === "/album")}>
            Álbum
          </Link>
          <a
            href="/#contato"
            data-testid="nav-contact"
            onClick={goContato}
            className={`${linkClass(false)} hidden sm:block`}
          >
            Contato
          </a>
          <a
            href={INSTAGRAM.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-instagram-link"
            aria-label="Instagram da SG Turismos"
            className="hidden h-9 w-9 items-center justify-center rounded-full border border-cloud text-navy transition-all duration-300 hover:bg-navy hover:text-paper sm:flex"
          >
            <Instagram size={15} strokeWidth={1.6} />
          </a>
          <a
            href={whatsappLink(WHATSAPP_DEFAULT_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-link"
            aria-label="WhatsApp da SG Turismos"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-cloud text-navy transition-all duration-300 hover:bg-navy hover:text-paper"
          >
            <WhatsAppIcon size={15} />
          </a>
        </nav>
      </div>
    </header>
  );
}
